module.exports = require("././release/angular-stripe.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-stripe (bower component)
 ** module id = 374
 ** module chunks = 1
 **/